import { useMemo } from "react";
import { Center } from "@chakra-ui/react";
import Head from "next/head";
import Hero from "@components/Institutions/Hero";
import Intro from "@components/Institutions/Intro";
import Why from "@components/Institutions/Why";
import Audits from "@components/Institutions/Audits";
import Investments from "@components/Institutions/Investments";
import ContactUs from "@components/Institutions/Contact";
import Footer from "@components/Landing/Footer";

const Institutions = () => {
  const getHeader = useMemo(() => {
    return (
      <Head>
        <title>
          Liquid restaking | Restake ETH or LSTs, mint rsETH and earn Kelp
          Miles!
        </title>
        <meta
          name="description"
          content="Unlock higher rewards and DeFi utility for restaked assets through liquid restaking with rsETH. Get dual rewards with EigenLayer Restaked Points and Kernel Points."
        />
        <link rel="icon" href="/favicon.ico" />
        <meta name="robots" content="index, follow" />
      </Head>
    );
  }, []);

  return (
    <>
      {getHeader}
      <Center flexDir="column" mt="24px">
        <Hero />
        <Intro />
        <Why />
        <Audits />
        <Investments />
        <ContactUs />
        <Footer bg="#075A5A" />
      </Center>
    </>
  );
};

export default Institutions;
